import { formatCurrencyAmount, priceInCurrency } from "utils";

export const isInstitutionPlan = (plan) => plan?.category?.toLowerCase() === "institution";
export const picksPolicy = (plan) => plan?.picks_policy || (isInstitutionPlan(plan) ? "unlimited" : "limited");
export const count = (value) => value !== null && value !== undefined && value !== "" && Number.isFinite(Number(value)) ? Math.max(0, Number(value)) : null;
export const displayCount = (value) => count(value)?.toLocaleString() ?? "—";

export function planDuration(plan) {
	const duration = count(plan?.duration);
	const unit = plan?.time_unit?.replace(/s$/, "");
	return duration && unit ? `${duration} ${unit}${duration === 1 ? "" : "s"}` : null;
}

export function planPrice(plan, currency) {
	const source = plan?.prices?.[currency] ? plan.prices[currency].amount : (currency === "USD" ? plan?.cost : currency === "ZWL" ? plan?.zwl_price : null);
	if (source === null || source === undefined || source === "" || !Number.isFinite(Number(source)) || Number(source) < 0) return null;
	const amount = priceInCurrency(plan?.prices, currency, plan?.cost, plan?.zwl_price);
	return amount === null ? null : formatCurrencyAmount(amount, currency);
}

export function individualUsage(plan) {
	const total = count(plan.max_number_of_books);
	const used = count(plan.current_premium_books_added);
	const remaining = count(plan.remaining) ?? (total !== null && used !== null ? Math.max(total - used, 0) : null);
	return { total, used, remaining };
}
